import { FC } from "react";
import { Spin } from "antd";

type LoadingProps = {
  isOverlay?: boolean;
  style?: any;
};

const Loading: FC<LoadingProps> = ({ isOverlay, style = {} }) => {
  return (
    <div
      style={
        isOverlay
          ? {
              position: "absolute",
              height: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
              backgroundColor: `rgba(255, 255, 255, 0.7)`,
              ...style,
            }
          : {
              height: window?.innerHeight ? window?.innerHeight - 210 : 800,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              ...style,
            }
      }
    >
      <Spin size="default" />
    </div>
  );
};

export default Loading;
